module.exports = __webpack_public_path__ + "static/media/logo-nare-sponsor.c6d80872.jpg";